import axios from 'helpers/axios';
import config from 'config';

const checkAccesRequest = token => axios({
  method: 'get',
  url: `${config.apiUrl}/checkAccess/${token}`,
});

export default checkAccesRequest;
